// src/index.js - 修正版
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRoot from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>
);